import React, { useState, useEffect, useRef } from 'react';
import {orbitRightLogo, rotate1, rotate2, rotate3, rotate4, rotate5 } from '../../../../../images';

const OrbitRightDesign = () => {
    const icons = [
  rotate1,
  rotate2,
  rotate3,
  rotate4,
  rotate5,
    ];
    const [isAnimating, setIsAnimating] = useState(false);
    useEffect(() => {
        const timer = setTimeout(() => setIsAnimating(true), 100);
        return () => clearTimeout(timer);
    }, []);

    const containerRef = useRef(null);
    const animationRef = useRef(null);

    useEffect(() => {
    let start = null;
    const duration = 60000;
    let frame;

    const animate = (timestamp) => {
        if (!start) start = timestamp;
        const elapsed = timestamp - start;
        const percent = (elapsed % duration) / duration;
        const angleOffset = percent * 2 * Math.PI;

        const container = containerRef.current;
        if (!container) return;

        const width = container.clientWidth;
        const height = container.clientHeight;

        // 🔹 Handle very small screens (like 200px)
        const minSize = Math.min(width, height);
        const isSmallScreen = minSize <= 220;

        const centerX = width / 2;
        const centerY = height / 2;

        // 🔹 Dynamic orbit radius (safe for 200px)
        const baseRadius = minSize / 2.8;
        const orbitRadius = isSmallScreen
        ? Math.max(baseRadius - 20, 40) // clamp for tiny screens
        : baseRadius;

        icons.forEach((_, index) => {
        const iconElem = container.children[index];
        if (!iconElem) return;

        // 🔹 Optional: scale icons on small screens
        if (isSmallScreen) {
            iconElem.style.transformOrigin = "center";
            iconElem.style.scale = "0.7";
        } else {
            iconElem.style.scale = "1";
        }

        const angle = (2 * Math.PI / icons.length) * index + angleOffset;

        const x =
            centerX +
            orbitRadius * Math.cos(angle) -
            iconElem.clientWidth / 2;

        const y =
            centerY +
            orbitRadius * Math.sin(angle) -
            iconElem.clientHeight / 2;

        iconElem.style.transform = `translate(${x}px, ${y}px)`;
        });

        frame = requestAnimationFrame(animate);
        animationRef.current = frame;
    };

    frame = requestAnimationFrame(animate);
    animationRef.current = frame;

    return () => cancelAnimationFrame(frame);
    }, [icons]);
    return (
        <div className="orbit-container">
            <style>{`
        .orbit-right-wrapper {
          position: relative;
          width: 550px;
          height: 550px;
          display: flex;
          align-items: center;
          justify-content: center;
          
        }

        .orbit-right-ring {
          position: absolute;
          border-radius: 50%;
          opacity: 0;
          background: rgba(244, 244, 254, 1);

        }

        .orbit-right-ring-1 {
          width: 500px;
          height: 500px;
          box-shadow: 0px 0px 50px 1px rgba(54, 43, 223, 0.15);
          animation: ${isAnimating ? 'firstringExpand 2s ease-out 0.2s infinite alternate' : 'none'};
        }
        .orbit-right-ring-2 {
          width: 400px;
          height: 400px;
          box-shadow: 0px 0px 50px 1px rgba(54, 43, 223, 0.15);
          animation: ${isAnimating ? 'ringExpand 2s ease-out 0.4s infinite alternate' : 'none'};
        }

        .orbit-right-ring-3 {
          width: 300px;
          height: 300px;
          box-shadow: 0px 0px 50px 1px rgba(54, 43, 223, 0.15);
          animation: ${isAnimating ? 'ringExpand 2s ease-out 0.8s infinite alternate' : 'none'};
        }

        .orbit-right-ring-4 {
          width: 200px;
          height: 200px;
          box-shadow: 0px 0px 50px 1px rgba(54, 43, 223, 0.15);
          animation: ${isAnimating ? 'ringExpand 2s ease-out 1.2s infinite alternate' : 'none'};
        }
        .orbit-right-ring-5{
          width: 100px;
          height: 100px;
          box-shadow: 0px 0px 50px 1px rgba(54, 43, 223, 0.15);
          animation: ${isAnimating ? 'ringExpand 2s ease-out 1.6s infinite alternate' : 'none'};
        }
        @keyframes firstringExpand {
        0% {
            transform: scale(1);
            opacity: 0.6;
        }
        100% {
            transform: scale(1);
            opacity: 1;
        }
        }

        @keyframes ringExpand {
        0% {
            transform: scale(0.92);
            opacity: 0.6;
        }
        100% {
            transform: scale(1);
            opacity: 1;
        }
        }


        .center-right-logo {
          position: absolute;
          width: 90px;
          height: 90px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0px 0px 50px 1px rgba(54, 43, 223, 0.15);
          z-index: 100;
          opacity: 0;
          transform: scale(0);
          animation: ${isAnimating ? 'logoAppear 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) 0.8s forwards, rightpulse 3s ease-in-out infinite' : 'none'};
          animation-delay: 0.8s, 2s;
        }

        @keyframes logoAppear {
          to {
            opacity: 1;
            transform: scale(1.1);
          }
        }

        @keyframes rightpulse {
          0%, 100% {
           box-shadow: 0px 0px 50px 1px rgba(54, 43, 223, 0.15) inset;
          50% {
            box-shadow: 0px 0px 50px 1px rgba(54, 43, 223, 0.15);
        }

        .logo-right-icon {
          font-size: 2.5rem;
          font-weight: 700;
          color: white;
          font-family: 'Outfit', sans-serif;
        }


      `}</style>

            <div className="orbit-right-wrapper">
                {/* Orbit Rings */}
                <div className="orbit-right-ring orbit-right-ring-1"></div>
                <div className="orbit-right-ring orbit-right-ring-2"></div>
                <div className="orbit-right-ring orbit-right-ring-3"></div>
                <div className="orbit-right-ring orbit-right-ring-4"></div>
                <div className="orbit-right-ring orbit-right-ring-5"></div>

                {/* Center Logo */}
                <div className="center-right-logo">
                    <div className="logo-right-icon"><img src={orbitRightLogo} className='img-fluid' alt="orbitLeftLogo"></img></div>
                </div>

                {/* Rotating icons */}
                <div
                    ref={containerRef}
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                    }}
                >
                    {icons.map((icon, idx) => (
                        <div
                            key={idx}
                            style={{
                                position: "absolute",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                filter: "drop-shadow(0px 0px 10px #ffffff)",
                                transition: "transform 0.2s ease-out",
                            }}
                        >
                            <img
                                src={icon}
                                alt={`icon-${idx}`}
                                style={{
                                    width: "auto",
                                    height: "clamp(24px, 4vw, 40px)", // ✅ responsive icon size
                                    objectFit: "contain",
                                }}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default OrbitRightDesign;